import { styled, alpha } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import COLORS from '../../../constants/colors';
import { APP_HEADER_HEIGHT } from '../../../constants/layout';

const drawerWidth = 264;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

/**
 * The header sits flush against the sidebar: same surface, same height and the
 * same hairline underneath, so the logo block and the account cluster read as
 * one band rather than two panels with a visible seam.
 */
export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  backgroundColor: COLORS.WHITE,
  borderBottom: `1px solid ${alpha(COLORS.MAIN_DARK, 0.08)}`,
  boxShadow: `0px 1px 2px ${alpha(COLORS.MAIN_DARK, 0.04)}`,
  height: `${APP_HEADER_HEIGHT}px`,
  zIndex: theme.zIndex.drawer - 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
